import { render, staticRenderFns } from "./query-result.vue?vue&type=template&id=5f0f0b10"
import script from "./query-result.vue?vue&type=script&lang=js"
export * from "./query-result.vue?vue&type=script&lang=js"
import style0 from "./query-result.vue?vue&type=style&index=0&id=5f0f0b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports